import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { useAuth } from "../lib/AuthContext";
import { useLang } from "../lib/LanguageContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const { t } = useLang();
    const nav = useNavigate();
    const [form, setForm] = useState({ username: "", password: "" });
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await login(form.username, form.password);
            toast.success("Welcome back");
            nav("/admin");
        } catch {
            toast.error("Invalid credentials");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F4EFE6] flex items-center justify-center px-6">
            <div className="w-full max-w-md">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 text-[#0F3A59] mb-8 hover:opacity-70 transition"
                    data-testid="back-to-site"
                >
                    <ArrowLeft size={16} />
                    <span className="text-sm tracking-wide">Back to site</span>
                </Link>
                <div className="bg-white rounded-2xl p-10 shadow-[0_20px_60px_rgb(0,0,0,0.08)]">
                    <div className="w-14 h-14 rounded-full bg-[#0F3A59] flex items-center justify-center mb-6">
                        <Lock size={22} strokeWidth={1.5} className="text-white" />
                    </div>
                    <h1 className="font-serif text-3xl text-[#0F3A59] tracking-tight">
                        {t("admin_login")}
                    </h1>
                    <p className="text-sm text-[#1C1C1C]/60 font-light mt-2">
                        Kompleksi Dea Radhimë — CMS
                    </p>
                    <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
                        <div>
                            <label className="text-xs uppercase tracking-wider text-[#1C1C1C]/70">
                                {t("username")}
                            </label>
                            <Input
                                value={form.username}
                                onChange={(e) =>
                                    setForm({ ...form, username: e.target.value })
                                }
                                required
                                className="mt-2 h-12 rounded-lg border-[#E5E0D8]"
                                data-testid="login-username"
                            />
                        </div>
                        <div>
                            <label className="text-xs uppercase tracking-wider text-[#1C1C1C]/70">
                                {t("password")}
                            </label>
                            <Input
                                type="password"
                                value={form.password}
                                onChange={(e) =>
                                    setForm({ ...form, password: e.target.value })
                                }
                                required
                                className="mt-2 h-12 rounded-lg border-[#E5E0D8]"
                                data-testid="login-password"
                            />
                        </div>
                        <Button
                            type="submit"
                            disabled={busy}
                            data-testid="login-submit"
                            className="w-full bg-[#0F3A59] hover:bg-[#1C5279] text-white h-12 rounded-full font-medium tracking-wide mt-2"
                        >
                            {busy ? t("loading") : t("login")}
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
}
